// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"685c39a134ae867f5333","293":"2be0cfaf31bb2ce71d90","518":"47ffafb56851894fdb90","779":"26c79973d25e858d6738"}[chunkId] + ".js";
};